const isExternalLink = (url) => {
  let isExternal = /^((http|https):\/\/)/.test(url) || /^www\./.test(url)
  if (typeof window !== 'undefined' && url && url.includes(window.location.hostname)) {
    isExternal = false
  }
  return isExternal
}

export default isExternalLink
